/**
 * Evaluates if the recipe requires user data by checking if the recipe has any
 * actions, tokens or conditions that require user data.
 *
 * @todo Implement this function. For now, it always returns false, allowing the user to remove the user selector.
 *
 * @return {Boolean} True if the recipe requires user data, false otherwise.
 */
const evaluateRecipeRequiresUserData = () => {
	return false;
}

export default evaluateRecipeRequiresUserData;